import { render, staticRenderFns } from "./StepFlowFooter.vue?vue&type=template&id=045eefa2&scoped=true&"
import script from "./StepFlowFooter.vue?vue&type=script&lang=js&"
export * from "./StepFlowFooter.vue?vue&type=script&lang=js&"
import style0 from "./StepFlowFooter.vue?vue&type=style&index=0&id=045eefa2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045eefa2",
  null
  
)

/* custom blocks */
import block0 from "./StepFlowFooter.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports